import React from "react";

const PtsDashboard = () => {
  return <div>PtsDashboard</div>;
};

export default PtsDashboard;
